import { render, staticRenderFns } from "./EnTramiteDePago.vue?vue&type=template&id=63380d0a&"
import script from "./EnTramiteDePago.vue?vue&type=script&lang=js&"
export * from "./EnTramiteDePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports